export default {
    scoreRanges: {},
    loading: false,
    error: null,
    errorShow: false
}